import React from 'react';
import Content from './content';
import Optimization from './optimization';
import Teaser from './teaser';
import ZInput from '../z-input';
import ZPages from '../z-pages';
import ZPage from '../z-page';
import ZToast from '../z-toast';
import FloatingSave from '../shared/components/floating-save/floating-save-view';
import Publications from './publications';
import Versions from './versions';
import UsageReferences from '../usage-references';
import PublishedStatus from '../shared/components/published-status';
import pageStyle from '../shared/styles/page.module.scss';
import sharedStyle from '../shared/styles/shared.module.scss';
import style from './article-editor.module.scss';
import Config from '../../config';

const baseUrlWeb = `${Config.Z3_URL}`;

const ArticleEditorView = ({
  btnText,
  disableSave,
  disabledSaveForDate,
  errors,
  id,
  onSave,
  onTitleChange,
  onToastClose,
  openToast,
  readOnly,
  saved,
  title,
  saveBtnDisabled,
  updateId,
}) => (
  <>
    <div className={pageStyle['landing-page']}>
      <h1>
        <ZInput
          error={errors && errors.title}
          label='Title'
          onUpdate={onTitleChange}
          initialValue={title}
          style={{margin: '14px 28px', fontSize: '22px'}}
          inputKey={'article__title'}
        />
      </h1>
      <div className={pageStyle['landing-page__header']} style={{display: 'flex', flexDirection: 'row'}}>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <PublishedStatus entityId={id} entityUpdateId={updateId} />
          <h2>{ saved ? 'Saved' : 'Not Saved' }</h2>
        </div>
        {readOnly && <h3 className={sharedStyle['read-only']}>Read Only View</h3>}
        <div className={pageStyle['preview-wrapper']}>
          <a
            className={`${pageStyle['preview-button']} ${sharedStyle['button']}`}
            href={`${baseUrlWeb}/dynamic?type=Article&id=${id}`}
            target='_blank'
            rel="noopener noreferrer"
          >
            Preview
          </a>
        </div>
      </div>
      <ZPages readOnly={readOnly}>
        <ZPage tabName='Creation' key={`${1}-Creation`}>
          <Content
            articleId={id}
          />
        </ZPage>
        <ZPage tabName='Optimization' key={`${2}-Optimization`}>
          <Optimization
            articleId={id}
          />
        </ZPage>
        <ZPage tabName='Teaser' key={`${2}-Teaser`}>
          <Teaser
            articleId={id}
          />
        </ZPage>
        <ZPage tabName="Usage References" key={`${4}-usageReferences`} >
          <UsageReferences entityId={id} />
        </ZPage>
        <ZPage tabName='Versions' key={`${5}-Versions`}>
          <Versions
            articleId={id}
            onSave={onSave}
          />
        </ZPage>
        <ZPage tabName='Publications' key={`${6}-Publications`}>
          <Publications />
        </ZPage>
      </ZPages>
      <div className={style['action-container']}>
        {(!title || disableSave) &&
          <p className={[`${sharedStyle.error} ${style['action-container__message']}`]}>
            A title is required to save.
          </p>
        }
      </div>
    </div>
    <ZToast
      open={openToast}
      onClose={onToastClose}
      message={'Article Saved!'}
    />
    <FloatingSave
      onClick={onSave}
      disabled={!title || disableSave || disabledSaveForDate || saveBtnDisabled}
      text={btnText}
    />
  </>
);

export default ArticleEditorView;
